import styled from 'styled-components';
import { Table as AntTable } from 'antd';

export const UiTable = styled(AntTable)`
`;